<template>
    <Checkbox :label="Strings['Shop.CheckboxNewsletter']" @change="updateWantsNewsletter($event)" :value="CurrentTransaction.wantsNewsletter" />
</template>

<script>
    import { mapState } from 'vuex'
    import Transaction from '@/models/Transaction'

    export default {
        methods: {
            updateWantsNewsletter(newValue) {
                let vm = this;
                Transaction.update({
                    id: vm.CurrentTransaction.id,
                    wantsNewsletter: newValue
                });
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            CurrentTransaction() {
                return Transaction.query().first();
            }
        }
    };
</script>